import * as RestClient from '../../utils/rest-service';
import Constants from '../../config/constants';

export const ACTION = {
  LIST_BOILER_TYPE: 'LIST_BOILER_TYPE',
  LIST_HEAT_PUMP_TYPE: 'LIST_HEAT_PUMP_TYPE',
};

export const listBoilerType = () => ({
  type: ACTION.LIST_BOILER_TYPE,
  payload: RestClient.request({
    method: 'get',
    url: Constants.API_REF_BOILER_TYPE,
  })
    .then(response => response.data)
    .catch(err => Promise.reject(err.response.data)),
});

export const listHeatPumpType = () => ({
  type: ACTION.LIST_HEAT_PUMP_TYPE,
  payload: RestClient.request({
    method: 'get',
    url: Constants.API_REF_HEAT_PUMP_TYPE,
  })
    .then(response => response.data)
    .catch(err => Promise.reject(err.response.data)),
});



// WEBPACK FOOTER //
// ./src/redux/references/hot_water_system_actions.js